import { defineComponent as _defineComponent } from 'vue'
import type { ChatMessage } from './types';

  interface Props {
    messages?: ChatMessage[];
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AiChatMessages',
  props: {
    messages: { default: () => [] }
  },
  setup(__props: any) {

  

return { __sfc: true, }
}

})